import dynamic from 'next/dynamic'

const Logo = dynamic(() => import('../../../HeaderComp/logo'))

const ADNewLogo = ({ isMobile }: { isMobile: boolean }) => (
  <Logo
    width={isMobile ? '4.1875rem' : '5rem'}
    height={isMobile ? '2.25rem' : '2.5rem'}
    margin={!isMobile && '0.5rem 0 0'}
    flexShrink="0"
  />
)

export default ADNewLogo
